<div *ngIf="downloadEnabled && data?.length" ngbDropdown placement="bottom-right" class="d-flex more-actions">
    <button class="action-icon sm"
            ngbDropdownToggle
            [attr.aria-label]="'Download or print files'">
        <far i="ellipsis-v"></far>
    </button>
    <div ngbDropdownMenu>
        <button (click)="onDownload('XLSX')"
                class="dropdown-item"
                [attr.aria-label]="'Download files as XLSX'">
            <fal i="download" class="icon"></fal>
            Download As .XLSX
        </button>
        <button (click)="onDownload('CSV')"
                class="dropdown-item"
                [attr.aria-label]="'Download files as CSV'">
            <fal i="download" class="icon"></fal>
            Download As .CSV
        </button>
        <button (click)="onPrint()"
                class="dropdown-item"
                [attr.aria-label]="'Print files'">
            <fal i="print" class="icon"></fal>
            Print
        </button>
    </div>
</div>

<ng-container *ngIf="apiFunction; else requestHandlerTable">
    <ng-container *ngTemplateOutlet="table; context: {hasLoading: true}"></ng-container>
</ng-container>
<ng-template #requestHandlerTable>
    <ng-container *appRequestHandler="requestHandler">
        <ng-container *ngTemplateOutlet="table; context: {hasLoading: false}"></ng-container>
    </ng-container>
</ng-template>

<ng-template #table let-hasLoading="hasLoading">
    <ng-container *ngIf="((hasLoading && !loading) || !hasLoading) && data?.length">
        <div #tableTmp [class.table-responsive]="hasScrollContainer">
            <table class="table table-sm small {{tableClasses}}" [class.table-hover]="definition.rowAction || reviewType">
                <thead>
                    <tr smart-table-header
                        [data]="data"
                        [definition]="definition"
                        [reviewType]="reviewType"
                        [selectable]="selectable"
                        [hasSorting]="hasSorting"
                        [sorting]="sorting"
                        [insertTemplateCols]="insertTemplateCols"
                        [shouldShowDetails]="showDetail"
                        [allRowsSelected]="allRowsSelected"
                        [paginated]="true"
                        (sortSelect)="onSortSelect($event)"
                        (selectAll)="selectAll($event)">
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngIf="!extraRowTemplate; else trWithExtraRow">
                        <ng-container *ngFor="let item of data">
                            <ng-container *ngTemplateOutlet="tr; context: {item:item}"></ng-container>
                        </ng-container>
                    </ng-container>
                    <ng-template #trWithExtraRow>
                        <ng-container *ngFor="let item of data">
                            <ng-container *ngTemplateOutlet="tr; context: {item:item}"></ng-container>
                            <ng-container *ngTemplateOutlet="extraRowTemplate; context: {item:item}"></ng-container>
                        </ng-container>
                    </ng-template>
                    <ng-template #tr let-item="item">
                        <tr smart-table-row
                            [definition]="definition"
                            [reviewType]="reviewType"
                            [item]="item"
                            [tableData]="data"
                            [selectable]="selectable"
                            [colTemplates]="colTemplates"
                            [insertTemplateCols]="insertTemplateCols"
                            [shouldShowDetails]="showDetail"
                            (openSlidePanel)="onOpenSlidePanel($event)"
                            (selectRow)="selectRow($event)"
                            [attr.data-test-id]="definition?.title">
                        </tr>
                    </ng-template>
                </tbody>
            </table>
        </div>
    </ng-container>

    <ng-container *ngIf="showPagination && data?.length">
        <app-pagination class="mt-3"
                        [hidden]="loading"
                        [count]="count"
                        [pageSize]="pageSize"
                        [currentPage]="page"
                        (pageChanged)="onPageChange($event)">
        </app-pagination>
        <div *ngIf="showPageSizeSelect"
             class="d-flex justify-content-center">
            <select [ngModel]="pageSize"
                    (ngModelChange)="onPageSizeChange($event)"
                    class="body-select"
                    [attr.aria-label]="'Select Page Size'">
                <option *ngFor="let option of pageSizeOptions" [ngValue]="option.value">{{option.name}}</option>
            </select>
        </div>
    </ng-container>

    <app-spinner *ngIf="loading" class="my-auto"></app-spinner>

    <ng-container *ngIf="!loading && !data?.length && !errorMsg">
        <div *ngIf="showNoData && !noDataMessage"
             class="text-muted">
            No data to show.
        </div>
        <app-illustration-message *ngIf="noDataMessage"
                                  [size]="noDataMessage.size"
                                  [iconName]="noDataMessage.iconName"
                                  [circleColor]="noDataMessage.circleColor"
                                  [title]="noDataMessage.title"
                                  [caption]="noDataMessage.caption"
                                  class="my-auto">
            <ng-content select=".no-data-message-content"></ng-content>
        </app-illustration-message>
    </ng-container>

    <app-error-message *ngIf="!loading && !data?.length && errorMsg"
                       [errorMsg]="errorMsg"
                       [error]="error">
    </app-error-message>
</ng-template>
